import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import styles from './input-text.module.scss';

interface InputTextProps extends Omit<UseControllerProps, 'control'> {
  name: string,
  control: any,
  rules?: any | null,
  widthLabel?: string,
  inline?: boolean
  label?: string | null,
  heading?: 1 | 2 | 3 | null,
  placeholder?: string,
  defaultValue?: string,
  className?: string,
  type?: string,
  handleChange?: (str: string) => void,
  handleFocus?: () => void,
  maxlength?: number,
  disabled?: boolean,
  focusOnError?: boolean,
}

const InputText:React.FC<InputTextProps> = ({
  name,
  control,
  rules,
  widthLabel = null,
  inline = false,
  label = null,
  heading = null,
  placeholder,
  defaultValue = '',
  type = 'text',
  className,
  handleChange,
  handleFocus,
  maxlength,
  disabled,
  focusOnError = true,
}) => {
  const {
    field: {
      value = '',
      ref,
      onChange,
      onBlur,
    },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  function handlePressEnter(e: any) {
    if (e.key === 'Enter' && e.target) {
      e.target.blur();
    }
  }

  const inputProps: Record<string, any> = {};

  if (maxlength) {
    inputProps.maxLength = maxlength;
  }

  function getClassName(): string {
    let strClassName = styles['container-input'];
    if (className) strClassName += ` ${styles[className]}`;
    if (inline) strClassName += ` ${styles.inlines}`;
    if (heading) strClassName += ` ${styles[`h${heading}`]}`;
    return strClassName;
  }

  return (
    <div
      onKeyUp={(e) => handlePressEnter(e)}
      className={getClassName()}
    >
      {label && <label style={widthLabel ? { minWidth: widthLabel } : {}}>
        {label}
        {rules && (<sup>*</sup>)}
      </label>}
      <input
        ref={focusOnError ? ref : null}
        disabled={disabled}
        type={type}
        value={value}
        onBlur={onBlur}
        onFocus={() => {
          if (typeof handleFocus === 'function') handleFocus();
        }}
        onChange={(e) => {
          if (handleChange) handleChange(e.target.value);
          onChange(e.target.value);
        }}
        className={styles.input}
        placeholder={placeholder}
        {...inputProps}
      />
    </div>
  );
};

export default InputText;
